import { render, staticRenderFns } from "./BundleIncludedProducts.vue?vue&type=template&id=ffeada98&scoped=true&"
import script from "./BundleIncludedProducts.vue?vue&type=script&lang=ts&"
export * from "./BundleIncludedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./BundleIncludedProducts.vue?vue&type=style&index=0&id=ffeada98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeada98",
  null
  
)

export default component.exports